<template>
  <div class="el-section">
    <section class="el-section">
      <div class="el-chunk">
        <h2 class="emd-text _size_page">
          {{ $t('title') }}
        </h2>
      </div>
      <p class="el-chunk">
        {{ $t('subtitle') }}
      </p>
    </section>
    <section class="el-section" v-if="accountSummary">
      <div class="el-grid-list">
        <div class="emd-container _type_card _content_spaced _footer_end eu-height_100" :class="{'eu-bg_success': hasCheckoutEnabled}">
          <div class="emd-container__content">
            <div class="eu-flex">
              <div class="eu-flex-item eu-basis_12 eu-basis_10_md">
                <p class="emd-text _size_section">
                  {{ $t('configurations.checkout') }}
                </p>
              </div>
            </div>
          </div>
          <div class="emd-container__footer">
            <p class="emd-text _type_label eu-pt_4" :class="{'_color_success': hasCheckoutEnabled, '_color_subtle': !hasCheckoutEnabled}">
              <span v-if="hasCheckoutEnabled">
                <i class="uil uil-check"></i> {{ $t('configurations.status.configured') }}
              </span>
              <span v-else>{{ $t('configurations.status.notConfigured') }}</span>
            </p>
          </div>
        </div>
        <div class="emd-container _type_card _content_spaced _footer_end eu-height_100" :class="{'eu-bg_success': hasPaymentMethodsEnabled}">
          <div class="emd-container__content">
            <div class="eu-flex">
              <div class="eu-flex-item eu-basis_12 eu-basis_10_md">
                <p class="emd-text _size_section">
                  {{ $t('configurations.paymentMethods') }}
                </p>
              </div>
            </div>
          </div>
          <div class="emd-container__footer">
            <p class="emd-text _type_label eu-pt_4" :class="{'_color_success': hasPaymentMethodsEnabled, '_color_subtle': !hasPaymentMethodsEnabled}">
              <span v-if="hasPaymentMethodsEnabled">
                <i class="uil uil-check"></i> {{ $t('configurations.status.configured') }}
              </span>
              <span v-else>{{ $t('configurations.status.notConfigured') }}</span>
            </p>
          </div>
        </div>
        <div class="emd-container _type_card _content_spaced _footer_end eu-height_100" :class="{'eu-bg_success': hasOpenOrdersEnabled}">
          <div class="emd-container__content">
            <div class="eu-flex">
              <div class="eu-flex-item eu-basis_12 eu-basis_10_md">
                <p class="emd-text _size_section">
                  {{ $t('configurations.createOrder') }}
                </p>
              </div>
            </div>
          </div>
          <div class="emd-container__footer">
            <p class="emd-text _type_label eu-pt_4" :class="{'_color_success': hasOpenOrdersEnabled, '_color_subtle': !hasOpenOrdersEnabled}">
              <span v-if="hasOpenOrdersEnabled">
                <i class="uil uil-check"></i> {{ $t('configurations.status.configured') }}
              </span>
              <span v-else>{{ $t('configurations.status.notConfigured') }}</span>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="el-section">
      <div v-if="hasAccessToConfigureDash" class="eu-align_right">
        <a class="emd-btn _color_primary" :href="urlDash">
          <i class="uil uil-external-link-alt"></i>
          {{ $t('configurations.access') }}
        </a>
      </div>
      <p v-else>
        {{ $t('configurations.contactAdmin') }}
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContinueConfig',
  computed: {
    accountSummary () {
      return this.$store.getters.accountSummary
    },
    paymentMethodsEnabled () {
      return this.$store.getters.paymentMethodsEnabled
    },
    merchantId () {
      return this.$store.getters.merchantData.id
    },
    accountId () {
      return this.$store.getters.accountData.id
    },
    urlDash () {
      return `${process.env.VUE_APP_DASH_URL}/${this.merchantId}/${this.accountId}/settings/order-config`
    },
    missingConfig () {
      return this.$store.getters.missingConfig
    },
    hasCheckoutEnabled () {
      return !this.missingConfig.includes('Account.Checkout.Settings.Enabled')
    },
    hasPaymentMethodsEnabled () {
      return !this.missingConfig.includes('Account.Payment.Methods')
    },
    hasOpenOrdersEnabled () {
      return !this.missingConfig.includes('Account.Inactive')
    },
    hasAccessToConfigureDash () {
      return this.accountSummary.user_has_access_to_configure_via_dash && this.permissionIsEnabled('shop.merchant_settings:edit')
    }
  },
  methods: {
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Falta pouco! Configure sua conta para começar a vender",
      "subtitle": "Para criar pedidos você precisa:",
      "configurations": {
        "checkout": "Ativar e integrar o Checkout Mundipagg nessa conta.",
        "paymentMethods": "Ter ao menos um dos meios de pagamento habilitados: Boleto ou Cartão de crédito.",
        "createOrder": "Permitir a criação de pedidos do tipo aberto na conta.",
        "contactAdmin": "Entre em contato com o administrador da conta para fazer as configurações necessárias.",
        "access": "Acessar configurações",
        "status": {
          "configured": "Configurado",
          "notConfigured": "Não Configurado"
        }
      }
    },
    "en-US": {
      "title": "You're close! Configure your account to start selling",
      "subtitle": "To create orders you need:",
      "configurations": {
        "checkout": "Activate and integrate Mundipagg's Checkout at this account.",
        "paymentMethods": "Have at least one payment method enabled: Boleto or Credit Card.",
        "createOrder": "Allow creating orders of kind open in the account.",
        "contactAdmin": "Contact the account's administrator to make the configurations needed.",
        "access": "Access configurations",
        "status": {
          "configured": "Configured",
          "notConfigured": "Not Configured"
        }
      }
    }
  }
</i18n>
